module.exports = {
    url: '/api'
}